import React, { useEffect, useRef } from "react";

type OutsideClickWatchProps = React.PropsWithChildren<{
    onOutsideClick: () => void;
    isWatching: boolean;
}>;

export const OutsideClickWatch: React.FC<OutsideClickWatchProps> = ({
    children,
    onOutsideClick,
    isWatching
}: OutsideClickWatchProps) => {
    const wrapperNode = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (isWatching && wrapperNode && wrapperNode.current) {
            document.addEventListener("mousedown", handleEventOutsideWatch);
            document.addEventListener("pointerdown", handleEventOutsideWatch);
        }

        return () => {
            document.removeEventListener("mousedown", handleEventOutsideWatch);
            document.removeEventListener("pointerdown", handleEventOutsideWatch);
        };
    }, [wrapperNode, isWatching]);

    const handleEventOutsideWatch = (event: UIEvent) => {
        if (
            wrapperNode &&
            wrapperNode.current &&
            !wrapperNode.current.contains(event.target as HTMLElement) &&
            document.body.contains(event.target as HTMLElement)
        ) {
            onOutsideClick();
        }
    };

    return <div ref={wrapperNode}>{children}</div>;
};
